// extracted by mini-css-extract-plugin
module.exports = {"story":"story_story__2yF7O","story-controls":"story_story-controls__bpYKP","hide-on-mobile":"story_hide-on-mobile__1ohwe","only-on-mobile":"story_only-on-mobile__2WZYC"};